import api from './api'
import type {
  ProjectApiKeyListResponse,
  ProjectApiKeyCreateRequest,
  ProjectApiKeyCreateResponse,
  ProjectApiKeyRevokeResponse,
} from '@/schemas/project-api-key'
import type { AxiosRequestConfig } from 'axios'

export const projectApiKeyService = {
  async listApiKeys(
    projectId: string,
    config?: AxiosRequestConfig
  ): Promise<ProjectApiKeyListResponse> {
    const response = await api.get<ProjectApiKeyListResponse>(
      `/projects/${projectId}/api-keys`,
      config
    )
    return response.data
  },

  async createApiKey(
    projectId: string,
    data: ProjectApiKeyCreateRequest,
    config?: AxiosRequestConfig
  ): Promise<ProjectApiKeyCreateResponse> {
    const response = await api.post<ProjectApiKeyCreateResponse>(
      `/projects/${projectId}/api-keys`,
      data,
      config
    )
    return response.data
  },

  async revokeApiKey(
    projectId: string,
    apiKeyId: string,
    config?: AxiosRequestConfig
  ): Promise<ProjectApiKeyRevokeResponse> {
    const response = await api.delete<ProjectApiKeyRevokeResponse>(
      `/projects/${projectId}/api-keys/${apiKeyId}`,
      config
    )
    return response.data
  },
}
